import React from "react";
import Paper from "@mui/material/Paper";
import FormFader from "../../Common/Fader/FormFader";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import { dateFieldDefault, isRequired, pastDateDefault, requiredValidator } from "../../../../services/validationRules";
import FormSubmit from "../../Common/FormSubmit/FormSubmit";
import { useForm } from "../../../../provider/Form/FormProvider";
import ValidatorSelectField from "../../../FormFields/ValidatorSelectField";
import Typography from "@mui/material/Typography";
import FormLegend from "../../Common/FormLegend/FormLegend";
import ValidatorDateField from "../../../FormFields/ValidatorDateField";
import FormSubmitProps from "../../../../types/FormSubmitProps";
import wizardStyle from "../../wizardStyle";
import { Box } from "@mui/material";

type AlimonyProps = { submitProps: FormSubmitProps };

export default function Alimony({ submitProps }: AlimonyProps) {
  const { values, handleSubmit } = useForm();

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h5"} sx={wizardStyle.headline}>
            Familiäre Situation
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>Wie ist die aktuelle Situation zwischen Ihnen und Ihrem Ex-Partner?</FormLegend>
            </Grid>
            {values.basicChoice === "complete" && (
              <Grid size={12}>
                <ValidatorDateField
                  name="dateMarriage"
                  label="Datum standesamtliche Heirat"
                  validators={[
                    { validator: isRequired, message: "Bitte geben Sie das Datum der standesamtlichen Heirat an" },
                    dateFieldDefault,
                    pastDateDefault,
                  ]}
                />
              </Grid>
            )}
            <Grid size={12}>
              <ValidatorSelectField
                label="Sind Sie getrennt?"
                name="areSeparated"
                validators={[requiredValidator("Bitte geben Sie an, ob Sind Sie getrennt sind.")]}
                MenuProps={{ slotProps: { paper: { style: { maxHeight: 200 } } } }}
              >
                <MenuItem value={"yes"}>Ja</MenuItem>
                <MenuItem value={"no"}>Nein</MenuItem>
              </ValidatorSelectField>
            </Grid>
            {values.areSeparated === "yes" && (
              <Grid size={12}>
                <ValidatorDateField
                  name="dateSeparation"
                  label="Datum der Trennung"
                  validators={[requiredValidator("Bitte geben Sie das Datum der Trennung an"), dateFieldDefault, pastDateDefault]}
                />
              </Grid>
            )}
            {values.basicChoice === "complete" && (
              <>
                <Grid size={12}>
                  <ValidatorSelectField
                    label="Sind Sie geschieden?"
                    name="areDivorced"
                    validators={[requiredValidator("Bitte geben Sie an, ob Sind Sie geschieden sind.")]}
                    MenuProps={{ slotProps: { paper: { style: { maxHeight: 200 } } } }}
                  >
                    <MenuItem value={"yes"}>Ja</MenuItem>
                    <MenuItem value={"no"}>Nein</MenuItem>
                  </ValidatorSelectField>
                </Grid>
                {values.areDivorced === "yes" && (
                  <Grid size={12}>
                    <ValidatorDateField
                      name="dateDivorce"
                      label="Datum der Scheidung"
                      validators={[requiredValidator("Bitte geben Sie das Datum der Scheidung an"), dateFieldDefault, pastDateDefault]}
                      helperText={"Geben Sie hier an, wann Ihre Scheidung rechtskräftig wurde"}
                    />
                  </Grid>
                )}
              </>
            )}
            <Grid size={12}>
              <Grid size={12}>
                <ValidatorSelectField
                  label="Anzahl unterhaltsberechtigter Kinder"
                  name="numberOfChildren"
                  helperText="Bitte tragen Sie die Gesamtzahl aller Kinder ein, denen gegenüber Sie oder Ihr bzw. Ihre (Ex-)Ehepartner/in unterhaltspflichtig sind. Zu berücksichtigen sind ausschließlich minderjährige Kinder sowie volljährige Kinder, die sich in ihrer ersten Berufsausbildung oder in einem Studium befinden und ihren Lebensunterhalt nicht aus eigenen Mitteln decken."
                  validators={[requiredValidator("Bitte geben Sie die Anzahl aller Kinder an")]}
                >
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                  <MenuItem value="6">6</MenuItem>
                  <MenuItem value="7">7</MenuItem>
                  <MenuItem value="8">8</MenuItem>
                  <MenuItem value="9">9</MenuItem>
                  <MenuItem value="10">10</MenuItem>
                </ValidatorSelectField>
              </Grid>
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
